// Шапка сайта (макет «Главная · развилка», «Компьютер · главная», версия 34): логотип, разделы,
// гостю — «Войти», вошедшему — «Мои заказы». На телефоне разделы — в меню. В Mini App шапки нет.
import { useState } from "react";
import { Link } from "react-router";
import { useCatalog, useMe } from "../app/queries";
import { Button, IconButton } from "../ui/Button";
import { Logo } from "../ui/Logo";
import { formatRub, lowestPrintPrice } from "./prices";
import styles from "./SiteHeader.module.css";

// Разделы на компьютере.
const NAV = [
  { to: "/mini", label: "Миниатюры" },
  { to: "/gift", label: "Любой образ" },
  { to: "/how", label: "Как это работает" },
  { to: "/faq", label: "Вопросы" },
];

export function SiteHeader({ gift = false }: { gift?: boolean }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const { data: me } = useMe();
  const { data: catalog } = useCatalog();
  const signedIn = me != null;
  const guest = me === null;
  const miniPrice = catalog ? lowestPrintPrice(catalog, "miniature") : null;
  const giftPrice = catalog ? lowestPrintPrice(catalog, "gift") : null;
  const closeMenu = () => setMenuOpen(false);
  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <Logo gift={gift} />
        <nav className={styles.nav} aria-label="Разделы">
          {NAV.map((link) => (
            <Link key={link.to} to={link.to}>
              {link.label}
            </Link>
          ))}
        </nav>
        <div className={styles.actions}>
          {signedIn && (
            <Link to="/orders" className={styles.link}>
              Мои заказы
            </Link>
          )}
          {guest && (
            <>
              <Link to="/login" className={`${styles.link} ${styles.mobileOnly}`}>
                Войти
              </Link>
              <span className={styles.desktopOnly}>
                <Button to="/login" compact fullWidth={false}>
                  Войти
                </Button>
              </span>
            </>
          )}
          <span className={styles.menuButton}>
            <IconButton
              icon={menuOpen ? "close" : "menu"}
              label={menuOpen ? "Закрыть меню" : "Меню"}
              onClick={() => setMenuOpen(!menuOpen)}
            />
          </span>
        </div>
      </div>
      {menuOpen && (
        <nav className={styles.menu} aria-label="Меню">
          <Link to="/mini" onClick={closeMenu}>
            Миниатюры для игры
            {miniPrice !== null && <span className={`mono ${styles.menuPrice} mini`}>от {formatRub(miniPrice)}</span>}
          </Link>
          <Link to="/gift" onClick={closeMenu}>
            Фигурка в любом образе
            {giftPrice !== null && <span className={`mono ${styles.menuPrice} gift`}>от {formatRub(giftPrice)}</span>}
          </Link>
          <Link to="/how" onClick={closeMenu}>
            Как это работает
          </Link>
          <Link to="/faq" onClick={closeMenu}>
            Вопросы
          </Link>
          <Link to="/docs" onClick={closeMenu}>
            Документы и возврат
          </Link>
          <div className={`${styles.menuAction} mini`}>
            {guest && (
              <>
                <Button to="/login">Войти</Button>
                <p className="small muted" style={{ textAlign: "center" }}>
                  По номеру телефона, без пароля
                </p>
              </>
            )}
            {signedIn && <Button to="/orders">Мои заказы</Button>}
          </div>
        </nav>
      )}
    </header>
  );
}
